'use client'

import { cn } from '@/lib/utils'
import { Typo3Webcam } from '@/types'
import { memo, useEffect, useState } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  data: Typo3Webcam
  variant?: 'map' | 'panorama'
  hideImage?: boolean
}

const generateRandomHash = (length: number) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

const CardWebcam = ({ data, variant = 'map', hideImage, ...props }: Props) => {
  const imageVariant = variant === 'panorama' ? 'medium' : 'thumbnail'
  const [imageUrl, setImageUrl] = useState('')

  useEffect(() => {
    const image = `${data.images?.[imageVariant]}${data.images?.[imageVariant]?.includes('?') ? '&' : '?'}r=${generateRandomHash(16)}`

    setTimeout(() => {
      setImageUrl(image)
    }, 10)
  }, [data])

  return (
    <div
      className={cn('group cursor-pointer bg-neutral-200 text-neutral-600')}
      {...props}
    >
      {!hideImage && imageUrl && (
        <div
          className={cn(
            'relative aspect-video w-full overflow-hidden',
            variant === 'map' ? 'aspect-video' : 'aspect-wide'
          )}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={imageUrl}
            alt={data.title}
            className="image-hover-effect h-full w-full object-cover object-center"
          />
        </div>
      )}
      <div className="p-md">
        <p className="textstyle-sm-regular line-clamp-2 text-neutral-400">
          {data.title}
        </p>
        <p className="textstyle-sm-bold" title={data.mountain}>
          {data.mountain}
        </p>
      </div>
    </div>
  )
}

export default memo(CardWebcam)
